module.exports = __webpack_public_path__ + "static/media/Chi.b5e99880.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Images/Home/Chi.png
// module id = 144
// module chunks = 7